import { PublicCallback } from 'globals/types';
import { validateEventType } from 'core_main/helpers/events';
import { KustomerEventTypes } from 'core_main/types';
import { addListenerToStore } from 'core_main/store';

export const addListener = (type: KustomerEventTypes, cb?: PublicCallback) => {
  const isEventValid = validateEventType(type);

  if (isEventValid === false) return;

  if (typeof cb === 'function') {
    addListenerToStore(type, cb);
  }
};
